/**
 * Helper to create custom drag images for desktop drag operations
 */
import COLOR_THEMES from "../../../../../colorThemes";
import config from "../store/sqftConfig";

export const createCustomDragImage = (imageUrl, text, width = 100, height = 100) => {
  // Create off-screen canvas
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');

  // Style the drag preview
  ctx.fillStyle = 'white';
  ctx.fillRect(0, 0, width, height);

  // Add border
  ctx.strokeStyle = COLOR_THEMES[config.activeTheme].primary;
  ctx.lineWidth = 1;
  ctx.strokeRect(0, 0, width, height);

  // Create container div for complex drag preview
  const dragPreview = document.createElement('div');
  dragPreview.style.cssText = `
    position: absolute;
    left: -9999px;
    top: -9999px;
    width: ${width}px;
    height: ${height}px;
    background: white;
    border: 2px solid #2196F3;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.2);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 4px;
    box-sizing: border-box;
  `;

  // Add image
  if (imageUrl) {
    const img = document.createElement('img');
    img.src = imageUrl;
    img.style.cssText = `
      max-width: 100%;
      max-height: ${height - 30}px;
      object-fit: contain;
    `;
    dragPreview.appendChild(img);
  }

  // Add text
  if (text) {
    const textDiv = document.createElement('div');
    textDiv.textContent = text;
    textDiv.style.cssText = `
      font-size: 10px;
      color: #333;
      text-align: center;
      margin-bottom: 2px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
    `;
    dragPreview.prepend(textDiv);
  }

  document.body.appendChild(dragPreview);

  return {
    element: dragPreview,
    cleanup: () => {
      if (dragPreview.parentNode) {
        dragPreview.parentNode.removeChild(dragPreview);
      }
    }
  };
};
